import { DatePipe } from '@angular/common';
import { VehiculosService } from './../../../../services/vehiculos.service';
import { MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../../../../views/auth/auth.service';


@Component({
	selector: 'kt-vehiculo-ultima-transmision',
	templateUrl: './vehiculo-ultima-transmision.component.html',
	styleUrls: ['./vehiculo-ultima-transmision.component.scss']
})
export class VehiculoUltimaTransmisionComponent implements OnInit {
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public datosReporte = [];
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"
	private HWUser;
	private HWAutos;
	 isDisabled: boolean = true;
	vehiculos: Autos[];

	constructor(private vehiculosService: VehiculosService,
		private authService: AuthService,
		private mapaService: MapaService,
		private datepipe: DatePipe,
		public dialogRef: MatDialogRef<VehiculoUltimaTransmisionComponent>) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);

	}

	ngOnInit() {
		this.HWUser = this.authService.getHWUser();
		this.obtenerHWAutos();
		this.getVehiculos();

	}

	getVehiculos() {
		/*let token = ''
		if (this.HWUser) {
			token = this.HWUser.token;
		}*/
		this.vehiculosService.obtenerAutos().subscribe(
			(vehiculos: Autos[]) => {
				vehiculos.map(vehiculo => {
					vehiculo.fechaHoraUltimaPosicion = this.datepipe.transform(vehiculo.fechaHoraUltimaPosicion, 'yyyy-MM-dd h:mm a');
				})
				this.vehiculos = vehiculos;
				this.vehiculos.forEach(vehiculo => {
					this.datosReporte.push({
						'ID': vehiculo.id,
						'Placa': vehiculo.placas,
						'Económico': vehiculo.economico,
						'Última Transmisión': vehiculo.fechaHoraUltimaPosicion,
					});
				});
				if(this.datosReporte.length > 0){
					this.isDisabled = false;
				}
				//this.pintarMarcadoresAutos(vehiculos);
			})
	}

	obtenerHWAutos() {
		//this.HWAutos = this.ultima;
		this.vehiculosService.obtenerUltimaPosicionAutosCamara('-1', -1).subscribe(
			(response: any) => {
				this.HWAutos = response
			}, (error) => {
				console.log('error::::: ', error);

			});
	}


	public pintarMarcadoresAutos(autos: Autos[]) {
		if (this.HWAutos) {
			autos.forEach(auto => {
				let value = this.HWAutos.filter(function (data) { return data.id === auto.imeiFk.toString() })
				if (value.length) {
					let autoHW = value[0];

					let ignicion = 0;
					let estado = 0
					if (Number(autoHW.ignicion) > 5) {
						ignicion = 1;
						estado = 1;
					}

					auto.id = Number(autoHW.id)
					auto.lat = Number(autoHW.lat);
					auto.lng = Number(autoHW.lng);
					auto.estado = estado;
					auto.ignicion = ignicion;
					auto.velocidad = Number(autoHW.velocidad);
					auto.fechaHoraUltimaPosicion = autoHW.fechaHoraUltimaPosicion
				}

			});
			//this.mapaService.registroVehiculos = autos;

			this.vehiculos = autos;

		} else {
			this.vehiculos = autos;

		}


	}

	ubicarPuntoHistorico(data) {
		this.mapaService.verVehiculo(data);
		this.cerrarPopup();
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

}
